export default {"src":"https://webcdn.trailways.ca/_next/static/media/copy.87e3a8bf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};